<template>
    <transition name="modal">
        <div class="modal__mask modalpep" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_pep">
                            <img class="modal__icon" src="@/assets/question.png" alt="Ícone de interrogação" />
                            <h2>PEP - Pessoa Exposta Politicamente </h2>

                            <span>
                                Consideram-se pessoas expostas politicamente os agentes públicos que desempenham ou tenham desempenhado, nos cinco anos anteriores, no Brasil ou em países, territórios e dependências estrangeiras, cargos, empregos ou funções públicas relevantes, assim como seus representantes, familiares e outras pessoas de seu relacionamento próximo, conforme disposto no Anexo A. 
                                <br/>
                                <br/>
                                <strong>Resolução CVM nº 50/2021, art. 5º, Anexo A e a Circular BCB nº 3.978/2020.</strong>
                            </span>

                            
                      <div class="buttonsAcoes">
                          <button class="btnDefault btn__entendi" @click="closeModal">Entendi</button>
                      </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PEP_INFORMATIVO",
            user: 'auth/user',
        }),
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_PEP_INFORMATIVO", false);
            
        },
    },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.inner__modal_pep {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
}

.inner__modal_pep .modal__icon {
    width: 40px;
    height: 47px;
}

.inner__modal_pep h2 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    text-align: center;
}

.inner__modal_pep span {
    font-size: 14px;
    line-height: 1.6;
    color: #555;
    text-align: justify;
}

.inner__modal_pep .buttonsAcoes {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 30px;
}

.inner__modal_pep .btn__entendi {
    width: 290px;
}
</style>
